/**
 * Aviso 148: a equipe pediu detalhes num chamado de suporte. O hub avisa; a HUD (linha Suporte
 * do menu Mais) e a janela de suporte escutam e recarregam o resumo.
 */
const EVENTO = 'uoidle:suporte-detalhes';

export function avisarSuporte(): void {
  window.dispatchEvent(new Event(EVENTO));
}

export function aoAvisoDeSuporte(fn: () => void): () => void {
  window.addEventListener(EVENTO, fn);
  return () => window.removeEventListener(EVENTO, fn);
}
